import { classSystemKeys } from "src/common/systemKey";
import { zId } from "src/types";
import z from "zod";

import { zSpecCommon } from "../specification";
import { zSecSpecRow } from "../specification/ZSecSpecRow";
import { zClassCommon } from "./ZClassRow";

export const zClassSysData = z.object({
  [classSystemKeys.first]: zClassCommon.pick({
    id: true,
    displayId: true,
  }),
  [classSystemKeys.secondParents]: z.object({
    parentIds: zId.array().nullish(),
  }),
  [classSystemKeys.primarySpec]: zSpecCommon.optional(),
  [classSystemKeys.secondarySpecs]: zSecSpecRow.array().optional(),
  [classSystemKeys.last]: zClassCommon.pick({
    createdAt: true,
    updatedAt: true,
    createdBy: true,
    updatedBy: true,
  }),
});
export type ZClassSysData = z.infer<typeof zClassSysData>;
